module.exports = __webpack_public_path__ + "static/media/logo-3.922204a3.png";